// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Q5qg","clinicsSelect":"styles_clinicsSelect__3XBs7"};